{
    "UsersByExtensions_ModalTitle": "Utilisateurs",
    "UsersByExtensions_Filters": "Filtres",
    "UsersByExtensions_AllPartitions": "Tous les sites",
    "UsersByExtensions_Header_Users": "Extension - Nom complet",
    "UsersByExtensions_Header_MS_Licences": "Licences MS",
    "UsersByExtensions_UserFields_Email": "Courriel",
    "UsersByExtensions_UserFields_Type": "Type d'abonnement",
    "UsersByExtensions_UserFields_UseEmailAsUser": "Utiliser l'email comme nom d'utilisateur",
    "UsersByExtensions_Username_Display_Title": "Nom d'utilisateur",
    "UsersByExtensions_Username_Display_Title_No_Username": "Pas de nom d'utilisateur\n(Vous ne pouvez pas créer cet utilisateur)",
    "UsersByExtensions_UserFields_LegacyAppend": "{} (héritage)",
    "UsersByExtensions_UserType_Legacy_Akixi Lite": "Lite",
    "UsersByExtensions_UserType_Legacy_Akixi ONE": "UN",
    "UsersByExtensions_UserType_Legacy_Akixi BLF": "Présence",
    "UsersByExtensions_UserType_Legacy_Akixi 1000": "1000",
    "UsersByExtensions_UserType_Legacy_Akixi 2000": "2000",
    "UsersByExtensions_UserFields_Checkbox_Tooltip": "Créer\/mettre à jour un utilisateur",
    "UsersByExtensions_UserFields_Cross_Tooltip": "Supprimer l'utilisateur",
    "UsersByExtension_UserType_NONE": "Surveillance désactivée (sans licence)",
    "UsersByExtension_UserType_ESSENTIALS": "L'essentiel",
    "UsersByExtension_UserType_ESSENTIALS_MST": "Norme CXA",
    "UsersByExtension_UserType_PROFESSIONAL": "Professionnel",
    "UsersByExtension_UserType_PROFESSIONAL_MST": "CXA Premium",
    "UsersByExtension_UserType_ENTERPRISE": "Entreprise",
    "UsersByExtension_UserType_ENTERPRISE_MST": "CXA avancé",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT": "Agent du centre d'appel",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_MST": "CXE Premium",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR": "Superviseur du centre d'appels",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_MST": "CXE avancé",
    "UsersByExtension_UserType_IsNotAgent": "Cet utilisateur a un agent. Si vous lui donnez cet abonnement, l'activité de l'agent ne sera plus surveillée.",
    "UsersByExtension_UserType_IsNone": "L'extension associée à cet utilisateur ne sera plus surveillée si vous lui donnez cet abonnement.",
    "UsersByExtension_Users_Multiple_Errors": "Plusieurs utilisateurs sont affectés à ce poste : {}",
    "UsersByExtensions_ConfirmUserDelete": "Cliquez à nouveau pour confirmer que vous souhaitez supprimer l'accès aux rapports.",
    "UserByExtension_LicenceTypes_EV": "Licence EV",
    "UserByExtension_LicenceTypes_None": "Utilisateur de l'équipe",
    "LicenceSummary_Title": "Résumé de la licence",
    "LicenceSummary_Headers_Type": "Type",
    "LicenceSummary_Headers_InUse": "En cours d'utilisation",
    "LicenceSummary_Types_Essentials": "L'essentiel",
    "LicenceSummary_Types_Essentials_MST": "Norme CXA",
    "LicenceSummary_Types_Professional": "Professionnel",
    "LicenceSummary_Types_Professional_MST": "CXA Premium",
    "LicenceSummary_Types_Enterprise": "Entreprise",
    "LicenceSummary_Types_Enterprise_MST": "CXA avancé",
    "LicenceSummary_Types_Unlicenced": "Sans licence",
    "AddAllUsers_Button_Title": "Créer des utilisateurs pour tous les postes non surveillés",
    "AddAllUsers_Button_Title_Interpolated": "Créer {} utilisateurs pour tous les postes non surveillés",
    "NoUsersAdded": "Aucun utilisateur n'a été ajouté",
    "TooManyUsers_NoLicences": "Impossible d'ajouter {} utilisateur car aucune licence n'est disponible",
    "TooManyUsers_UsersPlural_LicenceNonPlural": "Impossible d'ajouter {} utilisateurs car seule {} licence est disponible",
    "TooManyUsers_UsersNonPlural_LicenceNonPlural": "Impossible d'ajouter {} utilisateur car seule {} licence est disponible",
    "TooManyUsers_NoLicences_Plural": "Impossible d'ajouter {} utilisateurs car aucune licence n'est disponible",
    "TooManyUsers": "Impossible d'ajouter {} utilisateur car seules {} licences sont disponibles",
    "TooManyUsers_Plural": "Impossible d'ajouter {} utilisateurs car seules {} licences sont disponibles",
    "SuccessfullyAddedUsers": "Licence {} utilisateurs avec licence \"{}\" réussie",
    "AddAllUsers_PromptMessage": "Créer des utilisateurs pour tous les postes non surveillés avec licence \"{}\".\n\nToutes les modifications non enregistrées seront perdues. Êtes-vous sûr de vouloir continuer ?\n\n",
    "AddAllUsers_Confirm": "Confirmer",
    "AddAllUsers_Cancel": "Annuler",
    "AddAllUsers_CreatingUsers": "Ajout d'utilisateurs avec une licence \"{}\"...",
    "AddAllUsers_Loading": "Chargement...",
    "NAME": "UsersByExtension",
    "UsersByExtensions_UserFields_CRM_Integration": "Intégration CX",
    "UsersByExtension_CrmLicenceType_SOLO": "Intégration CRM Solo",
    "UsersByExtension_CrmLicenceType_TEAMS": "Intégration CRM Teams",
    "UsersByExtension_CrmLicenceType_UNITE": "Intégration CX",
    "UsersByExtension_CrmLicenceType_NONE": "Aucune intégration CRM",
    "LicenceSummary_Types_CallCentreAgent": "Agent de centre d'appels",
    "LicenceSummary_Types_CallCentreAgent_MST": "CXA Premium",
    "LicenceSummary_Types_CallCentreSupervisor": "Superviseur du centre d'appels",
    "LicenceSummary_Types_CallCentreSupervisor_MST": "CXA Avancé",
    "LicenceSummary_Types_CXIntegration": "Intégration CX",
    "ProvisionAllCrm_Button_Title_Interpolated": "Créer\/mettre à jour les utilisateurs avec la licence {}",
    "ProvisionAllCrm_PromptMessage": "Créez des utilisateurs pour toutes les extensions non surveillées avec {}. \n \n Toutes les modifications non enregistrées seront perdues, êtes-vous sûr de vouloir continuer ? \n \n",
    "TooManyUsers_MaxTelSysCapReached": "Impossible d'ajouter {} utilisateur car cela dépasserait le nombre maximal d'utilisateurs autorisés par le système téléphonique",
    "TooManyUsers_MaxTelSysCapReached_Plural": "Impossible d'ajouter {} utilisateurs car cela dépasserait le nombre maximum d'utilisateurs autorisé par le système téléphonique"
}